require('./bootstrap');

window.Vue = require('vue');

// import any requirements / dependencies
import VueRouter from 'vue-router';

// set name spaces
Vue.use(VueRouter)

// import the components
import QuoteComponent from './components/QuoteComponent';

 // create the vue application
const router = new VueRouter({
	mode: 'history',
	routes: [
		{ path: '/apply', component: QuoteComponent }
	]
});

const app = new Vue({
	el: '#app',
	router
});